import React from 'react';
import { DescriptionContainer } from './styles';

const TimelineStepDescription = ({ description }) => {
  return <DescriptionContainer>{description}</DescriptionContainer>;
};

export default TimelineStepDescription;
